import styled from '@emotion/styled';
export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
`;
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4.8rem;
`;
export const FormBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;
export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.8rem;
	width: 100%;
	height: 4.4rem;
`;

export const Danger = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	color: ${(props) => props.theme.colors.red600};
`;
export const CodeBox = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	color: #22a95e;
	background-color: #fcffc5;
	padding: 1rem;
	max-width: 17.6rem;
	width: 100%;
	height: 100%;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 120%;
	letter-spacing: -0.6px;
`;
export const GenderBox = styled.div`
	display: flex;
	gap: 4rem;
`;

export const GenderRadio = styled.div`
	display: flex;
	gap: 0.4rem;
	input[type='radio'] {
		-webkit-appearance: none; // 웹킷 브라우저에서 기본 스타일 제거
		-moz-appearance: none; // 모질라 브라우저에서 기본 스타일 제거
		appearance: none; // 기본 브라우저에서 기본 스타일 제거
		width: 20px;
		height: 20px;
		border: 1px solid #ced4da; // 체크되지 않았을 때의 테두리 색상
		border-radius: 50%;
		outline: none; // focus 시에 나타나는 기본 스타일 제거
		cursor: pointer;
	}
	// 체크 시 버튼 모양 스타일
	input[type='radio']:checked {
		background-color: #fff; // 체크 시 내부 원 색상
		border: 6px solid ${(props) => props.theme.colors.primary400}; // 라인이 아닌, 라인과 원 사이 색상
	}
	label {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.4rem;
		cursor: pointer;
	}
`;

export const SpotExplain = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #495057;
`;
export const NextButton = styled.button`
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: none;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
	}
`;
